import axios, { AxiosInstance, AxiosResponse } from 'axios'
import AuthToken from '@/auth/auth-token'

const DEPT_NOTIFICATIONS_ATTR = 'DEPARTMENT_NOTIFICATIONS'

interface NotificationPayload {
  title: string;
  body: string;
  to_all?: boolean;
  subscription_name?: string;
  upstream_party_id?: string;
  upstream_party_ids?: string[];
  upstream_party_name?: string;
  department_ids?: string[];
  email_list?: string[];
}

class Notification {
  protected readonly notification: AxiosInstance;

  constructor () {
    const notification = axios.create({
      baseURL: process.env.VUE_APP_NOTIFICATION_API,
      headers: {
        'Content-type': 'application/json'
      }
    })

    this.notification = notification
  }

  handleSuccess (response: AxiosResponse) {
    return response
  }

  handleError (error: any) {
    return Promise.reject(error)
  }

  private setAuth () {
    return AuthToken.setAuth(this.notification, { audience: process.env.VUE_APP_MOBILE_AUDIENCE })
  }

  public getDepartments = async () => {
    await this.setAuth()

    const response = await this.notification({
      url: '/user/mobile-preferences',
      method: 'GET'
    })
      .then(this.handleSuccess)
      .catch(this.handleError)

    const preferences = response?.data?.preferences ?? []
    const deptPref = preferences.find((p: any) => p.attr_id === DEPT_NOTIFICATIONS_ATTR)
    return deptPref?.options ?? []
  }

  public getAllHistory = async (limit?: number, offset?: number) => {
    await this.setAuth()

    const params: any = {}
    if (limit !== undefined) params.limit = limit
    if (offset !== undefined) params.offset = offset

    return this.notification({
      url: '/notifications/all-history',
      method: 'GET',
      params: params
    })
      .then(this.handleSuccess)
      .catch(this.handleError)
  }

  public previewRecipients = async (data: NotificationPayload) => {
    await this.setAuth()

    return this.notification({
      url: '/notifications/preview-recipients',
      method: 'POST',
      data: data
    })
      .then(this.handleSuccess)
      .catch(this.handleError)
  }

  public sendNotification = async (data: NotificationPayload) => {
    await this.setAuth()

    return this.notification({
      url: '/notifications/send',
      method: 'POST',
      data: data
    })
      .then(this.handleSuccess)
      .catch(this.handleError)
  }
}

export default new Notification()
